import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UiBlockerService {
  private readonly isBlocked = signal(false);

  get blocked() {
    return this.isBlocked.asReadonly();
  }

  block() {
    this.isBlocked.set(true);
  }

  unblock() {
    this.isBlocked.set(false);
  }
}
